import { STORYBLOK_TYPES } from '~/lib/storyblok-types'
import CategoryPage from '~/pages/category'

import getCategoryPageStaticPropsFunction from '~/data/category-page-data'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

export default CategoryPage

export const getStaticProps = getCategoryPageStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: false,
  type: STORYBLOK_TYPES.CATEGORY_PAGE,
  maxPathsInProduction: 10,
})
